import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import queryString from "query-string";

function useQueryParams() {
    const location = useLocation();

    const params = queryString.parse(location.search);

    return params;
}

function useLocationChange(callback) {
    const location = useLocation();

    useEffect(() => {
        // this runs on update of props.location (withRouter injects location into props)
        callback(location);
    }, [location]);
}

export { useQueryParams, useLocationChange };
